(() => {
  const KEY = "follow-theme";
  const ROOT = document.documentElement;
  const STYLE_ID = "follow-theme-b-runtime";

  const B_CSS = `
html[data-theme="b"],
html.theme-b,
html[data-theme="b"] body,
html.theme-b body,
html[data-theme="b"] .page-wrapper,
html.theme-b .page-wrapper,
html[data-theme="b"] .shopify-section,
html.theme-b .shopify-section,
html[data-theme="b"] [class*="color-scheme"],
html.theme-b [class*="color-scheme"],
html[data-theme="b"] [class*="color-custom-"],
html.theme-b [class*="color-custom-"],
html[data-theme="b"] header,
html.theme-b header,
html[data-theme="b"] footer,
html.theme-b footer,
html[data-theme="b"] .section-background,
html.theme-b .section-background,
html[data-theme="b"] .header-section,
html.theme-b .header-section,
html[data-theme="b"] #header-component,
html.theme-b #header-component,
html[data-theme="b"] .header,
html.theme-b .header,
html[data-theme="b"] .header__row--top,
html.theme-b .header__row--top {
  --follow-bg: #0c0c0d !important;
  --follow-bg-rgb: 12 12 13 !important;
  --follow-fg: #f5f1e9 !important;
  --follow-fg-rgb: 245 241 233 !important;
  --follow-button-bg: #f5f1e9 !important;
  --follow-button-fg: #0c0c0d !important;
  --color-background: #0c0c0d !important;
  --color-background-rgb: 12 12 13 !important;
  --color-foreground: #f5f1e9 !important;
  --color-foreground-rgb: 245 241 233 !important;
  --color: #f5f1e9 !important;
  --color-rgb: 245 241 233 !important;
  --color-border: #f5f1e9 !important;
  --color-border-rgb: 245 241 233 !important;
  --palette-lightest: #f5f1e9 !important;
  --palette-lightest-rgb: 245 241 233 !important;
  --palette-darkest: #0c0c0d !important;
  --palette-darkest-rgb: 12 12 13 !important;
  --color-primary-button-text: #0c0c0d !important;
  --color-primary-button-background: #f5f1e9 !important;
  --color-primary-button-border: #f5f1e9 !important;
  --color-primary-button-focus-outline: #f5f1e9 !important;
  --color-primary-button-hover-text: #0c0c0d !important;
  --color-primary-button-hover-background: #e8e2d4 !important;
  --color-primary-button-hover-border: #e8e2d4 !important;
  --color-secondary-button-text: #f5f1e9 !important;
  --color-secondary-button-background: transparent !important;
  --color-secondary-button-border: #f5f1e9 !important;
  --color-secondary-button-hover-text: #f5f1e9 !important;
  --color-secondary-button-hover-background: rgb(245 241 233 / 0.08) !important;
  --color-secondary-button-hover-border: #f5f1e9 !important;
  --color-input-background: #0c0c0d !important;
  --color-input-text: #f5f1e9 !important;
  --color-input-text-rgb: 245 241 233 !important;
  --color-input-border: #2a2a2c !important;
  background-color: #0c0c0d !important;
  color: #f5f1e9 !important;
}
html[data-theme="b"] .hero,
html.theme-b .hero,
html[data-theme="b"] .hero [class*="color-custom-"],
html.theme-b .hero [class*="color-custom-"] {
  background-color: transparent !important;
}
`;

  const syncRuntimeStyle = (theme) => {
    let el = document.getElementById(STYLE_ID);
    if (theme === "b") {
      if (!el) {
        el = document.createElement("style");
        el.id = STYLE_ID;
        el.textContent = B_CSS;
      }
      (document.head || document.body || document.documentElement).appendChild(el);
    } else if (el) {
      el.remove();
    }
  };

  const persist = (theme) => {
    try {
      localStorage.setItem(KEY, theme);
    } catch (e) {}
    try {
      document.cookie = KEY + "=" + theme + "; path=/; max-age=31536000; SameSite=Lax";
    } catch (e) {}
  };

  const storedTheme = () => {
    try {
      const stored = localStorage.getItem(KEY);
      if (stored === "b" || stored === "c") return stored;
    } catch (e) {}
    try {
      const match = document.cookie.match(/(?:^|; )follow-theme=(b|c)/);
      if (match) return match[1];
    } catch (e) {}
    return ROOT.getAttribute("data-theme") === "b" || ROOT.classList.contains("theme-b") ? "b" : "c";
  };

  const apply = (theme) => {
    const next = theme === "b" ? "b" : "c";
    ROOT.setAttribute("data-theme", next);
    ROOT.classList.toggle("theme-b", next === "b");
    ROOT.classList.toggle("theme-c", next === "c");
    ROOT.style.colorScheme = next === "b" ? "dark" : "light";
    if (document.body) {
      document.body.dataset.theme = next;
      document.body.classList.toggle("theme-b", next === "b");
      document.body.classList.toggle("theme-c", next === "c");
    }
    syncRuntimeStyle(next);
    persist(next);
    document.querySelectorAll("[data-follow-theme-toggle]").forEach((el) => {
      el.setAttribute("data-active-theme", next);
      el.querySelectorAll("[data-theme-value]").forEach((btn) => {
        const on = btn.getAttribute("data-theme-value") === next;
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    });
  };

  const fromEvent = (event) => {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];
    for (const node of path) {
      if (!node || !node.getAttribute) continue;
      if (node.closest && node.closest("a.follow-bag, a[data-follow-bag], .menu-drawer a, header-drawer a")) return null;
      if (node.getAttribute("data-theme-value")) return node;
    }
    const target = event.target;
    if (target && target.closest) {
      if (target.closest("a.follow-bag, a[data-follow-bag], .menu-drawer a, header-drawer a")) return null;
      return target.closest("[data-theme-value]");
    }
    return null;
  };

  let lastToggleAt = 0;
  const onToggleEvent = (event) => {
    const node = fromEvent(event);
    if (!node) return;
    const value = node.getAttribute("data-theme-value");
    const next = value === "b" || value === "c" ? value : storedTheme() === "b" ? "c" : "b";
    const now = Date.now();
    if (now - lastToggleAt < 450) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    lastToggleAt = now;
    event.preventDefault();
    event.stopPropagation();
    apply(next);
  };

  const forceBagLinks = () => {
    document.querySelectorAll("[data-follow-bag], a.action__cart, a.follow-bag, header-actions a[aria-label]").forEach((el) => {
      if (!(el instanceof HTMLAnchorElement)) return;
      const label = (el.getAttribute("aria-label") || "").toLowerCase();
      const isBag = el.hasAttribute("data-follow-bag") || el.classList.contains("action__cart") || el.classList.contains("follow-bag") || label === "cart" || label === "bag";
      if (!isBag) return;
      if (el.getAttribute("href") !== "/cart") el.setAttribute("href", "/cart");
      el.setAttribute("target", "_self");
      el.removeAttribute("aria-controls");
      el.removeAttribute("aria-haspopup");
    });
    document.querySelectorAll('[on\\:click="#cart-drawer/toggle"], [data-testid="cart-drawer-trigger"], button[aria-controls="cart-drawer"]').forEach((el) => {
      el.addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.assign("/cart");
        },
        true
      );
    });
  };

  const disableCartDrawerIntercept = () => {
    const actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.openCart && typeof actions.openCart.configure === "function") {
      actions.openCart.configure({
        async handler() {
          window.location.assign("/cart");
        },
      });
    }
  };

  const protectDrawerLinks = () => {
    document.querySelectorAll(".menu-drawer a, .menu-list a, header-drawer a, header-menu a").forEach((link) => {
      if (!(link instanceof HTMLAnchorElement)) return;
      const text = (link.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      let href = link.getAttribute("href") || "";
      if (text === "about" || href.indexOf("/pages/about") !== -1 || href.indexOf("/pages/our-story") !== -1) {
        href = "/pages/about";
        link.setAttribute("href", href);
      } else if (text === "contact" || href.indexOf("/pages/contact") !== -1) {
        href = "/pages/contact";
        link.setAttribute("href", href);
      }
      if (!href || href === "#" || href.indexOf("javascript:") === 0) {
        if (text === "about") link.setAttribute("href", "/pages/about");
        else if (text === "contact") link.setAttribute("href", "/pages/contact");
        else if (text === "shop" || text === "catalog") link.setAttribute("href", "/collections/all");
      }
      link.setAttribute("target", "_self");
    });
  };

  apply(storedTheme());
  document.addEventListener("pointerdown", onToggleEvent, true);
  document.addEventListener("click", onToggleEvent, true);
  document.addEventListener("touchend", onToggleEvent, true);

  const destForHeaderLink = (el) => {
    if (!(el instanceof Element)) return null;
    if (el.closest && el.closest("[data-theme-value]")) return null;
    const bag = el.closest("[data-follow-bag], a.follow-bag, a.action__cart, [data-testid=\"cart-drawer-trigger\"], button[aria-controls=\"cart-drawer\"]");
    if (bag) return "/cart";
    const link = el.closest(".menu-drawer a, header-drawer a, .header-menu a");
    if (!(link instanceof HTMLAnchorElement)) return null;
    const text = (link.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    if (text === "about" || text === "our story") return "/pages/about";
    if (text === "contact") return "/pages/contact";
    const href = (link.getAttribute("href") || "").split("?")[0];
    if (!href || href === "#" || href.indexOf("javascript:") === 0) {
      if (text === "shop" || text === "catalog") return "/collections/all";
    }
    return null;
  };

  const go = (event, dest) => {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    document.querySelectorAll("header-drawer details[open]").forEach((d) => {
      d.classList.remove("menu-open");
      d.removeAttribute("open");
    });
    window.location.assign(dest);
  };

  document.addEventListener(
    "click",
    (event) => {
      const raw = event.target;
      const el = raw instanceof Element ? raw : raw && raw.parentElement;
      const dest = destForHeaderLink(el);
      if (dest) go(event, dest);
    },
    true
  );

  const start = () => {
    if (document.body) document.body.dataset.theme = storedTheme();
    apply(storedTheme());
    forceBagLinks();
    protectDrawerLinks();
    disableCartDrawerIntercept();
    document.querySelectorAll("[data-follow-theme-toggle], [data-theme-value]").forEach((el) => {
      if (el.dataset.followThemeBound === "true") return;
      el.dataset.followThemeBound = "true";
      el.addEventListener("pointerdown", onToggleEvent);
      el.addEventListener("click", onToggleEvent);
      el.addEventListener("touchend", onToggleEvent);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  document.addEventListener("shopify:section:load", start);

  const keepHeaderOnScreen = () => {
    if (!window.matchMedia("(max-width: 699px)").matches) return;
    const header = document.getElementById("header-component");
    if (!header) return;
    const r = header.getBoundingClientRect();
    if (r.bottom < 48 || r.top < -8) {
      window.scrollTo(0, 0);
    }
  };
  window.addEventListener("pageshow", keepHeaderOnScreen);
  window.addEventListener("popstate", keepHeaderOnScreen);
})();
